export const ArrayUtils = {
  reduceById(values) {
    if (!Array.isArray(values)) {
      return {};
    }
    return values.reduce((acc, val) => {
      if (!val.id) {
        throw new Error(`reduceById found value without id ${val}`);
      }
      return {
        ...acc,
        [val.id]: val
      };
    }, {});
  },
  safeFilter(array, predicate) {
    if (!Array.isArray(array)) {
      return [];
    }
    return array.filter(item => {
      if (!predicate) {
        return Boolean(item);
      }
      return item != null && item && predicate(item);
    });
  }
};
//# sourceMappingURL=array.utils.js.map